export default {
    strict: true,
    fields: {
        plateNumber: {
            type: "string",
        },
        year: {
            type: "string",
        },
        model: {
            type: "string",
        },
    },
};
